import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { Table, TableRow, TableBody, TableCell, TableContainer, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack, Grid, Switch, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MyPagination from "./MyPagination";
import { createRoot } from "react-dom/client";
import { asyncRequest } from "src/services/network";
import ListHead from "./ListHead";
import MoreMenu from "./MoreMenu";
import SearchNotFound from "../SearchNotFound";
import ReactDOM from "react-dom";

const modalRoot = document.querySelector("#image-picker");

const TABLE_HEAD = [
  { id: 'id', label: 'ID', alignRight: false },
  { id: 'name', label: '名称', alignRight: false },
  // { id: 'category', label: '分类', alignRight: false },
  // { id: 'type', label: '类型', alignRight: false },
  { id: 'discount', label: '面值', alignRight: false },
  // { id: 'time', label: '有效期', alignRight: false },
  { id: 'stock', label: '发布数量', alignRight: false },
  { id: 'status', label: '状态', alignRight: false },
  { id: 'created', label: '发布时间', alignRight: false },
];


export const CouponPickerDialog = ({ title, multiple, visible, onClose, onSelect }) => {
  const ref = useRef();
  const [selected, setSelected] = useState([]);
  const [open, setOpen] = useState(visible);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
  });

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  useEffect(() => {
    getItems();
  }, [filter]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: '/coupon/list',
      data: filter,
    });

    setItems(data);
    setTotal(count);
  }

  const handleConfirmSelection = (row) => {
    // onSelect(selected.map((s) => s.path).join(","));
    onSelect([row]);
    setOpen(false);
  };

  function handlePageChange(event, page) {
    // setSelected([]);
    // setPage(page - 1);
  }

  function handleImgClick(item) {
    const imgs = [...selected];
    const idx = imgs.findIndex((a) => a.id === item.id);
    if (idx === -1) {
      if (imgs.length < 1 || multiple) {
        imgs.push(item);
      } else {
        imgs[0] = item;
      }
    } else {
      imgs.splice(idx, 1);
    }

    setSelected(imgs);
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="unset">
      <DialogTitle>
        {title}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              // color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      <DialogContent sx={{ minHeight: 530 }}>
        <TableContainer>
          <Table>
            <ListHead
              headLabel={TABLE_HEAD}
            />
            <TableBody>
              {items
                .map((row) => {
                  const { id, name, cover, status, category, type, reach, worth, discount, stock, createdAt, startTime, endTime } = row;
                  const isItemSelected = selected.indexOf(name) !== -1;

                  return (
                    <TableRow
                      hover
                      key={id}
                      tabIndex={-1}
                      role="checkbox"
                      selected={isItemSelected}
                      aria-checked={isItemSelected}
                      onClick={() => handleConfirmSelection(row)}
                    >
                      <TableCell align="left">{id}</TableCell>
                      <TableCell align="left">{name}</TableCell>
                      <TableCell align="left">{['', '洗车券', '油卡', '电卡', '商品'][type]}</TableCell>
                      {/* <TableCell align="left">{['满减券', '折扣券', '核验券'][type]}</TableCell> */}
                      <TableCell align="left">{worth}</TableCell>
                      {/* <TableCell align="left">{moment(startTime).format("YYYY-MM-DD HH:mm:ss")}</TableCell> */}
                      <TableCell align="left">{stock || '无限制'}</TableCell>
                      <TableCell align="left">
                        <Switch checked={status == 1} />
                      </TableCell>
                      <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
            {items.length === 0 && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                    <SearchNotFound searchQuery={filter.search} />
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>

        <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
      </DialogContent>
    </Dialog>
  );
};

let root = null;

// const CouponPicker = ({ title = "请选择优惠券", multiple = false, onSelect = () => { }, onClose = () => { } }) => {
//   if (!root) {
//     root = createRoot(modalRoot);
//   }
//   root.render(<CouponPickerDialog visible={true} onClose={() => {
//     root.unmount();
//     root = null;
//     onClose();
//   }} onSelect={onSelect} title={title} multiple={multiple} />);
// };

const CouponPicker = ({ title = "请选择优惠券", multiple = false, onSelect = () => { }, onClose = () => { } }) => {
  ReactDOM.unmountComponentAtNode(modalRoot);
  ReactDOM.render(<CouponPickerDialog visible={true} onClose={onClose} onSelect={onSelect} title={title} multiple={multiple} />, modalRoot);
};


export default CouponPicker;
